import React from 'react';

export default (props) => <thead>{props.children}</thead>;
